import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#312F2A",
      d: "M39.789 29.529c-.672-.61-1.72-.57-2.426 0l-5.261 4.208a3.63 3.63 0 0 1-2.278.797h-6.736a.914.914 0 0 1-.91-.911c0-.502.41-.911.91-.911h4.459c.905 0 1.748-.621 1.896-1.515a1.824 1.824 0 0 0-1.8-2.13h-9.11c-1.537 0-3.024.53-4.22 1.498l-2.647 2.146H8.512a.914.914 0 0 0-.911.912v5.466c0 .5.41.91.91.91h20.317c.825 0 1.628-.278 2.277-.796l8.61-6.89c.865-.689.933-2.01.074-2.784"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#312F2A",
      d: "M22.462 14.15a.769.769 0 1 0 0 1.537zm3.074 1.537a.768.768 0 0 0 0-1.537zm-3.074 3.843a.768.768 0 1 0 0 1.538zm9.224 1.538a.768.768 0 0 0 0-1.538zm-9.224 1.537a.769.769 0 1 0 0 1.537zm9.224 1.537a.768.768 0 1 0 0-1.537zm-9.224 1.538a.768.768 0 1 0 0 1.537zm3.074 1.537a.769.769 0 0 0 0-1.537zm-4.612-16.142h12.3V9.537h-12.3zm13.068.768v16.912h1.537V11.843zm-.769 17.68H20.924v1.538h12.3zm-13.067-.768V11.843h-1.538v16.912zm.768.768a.77.77 0 0 1-.768-.768h-1.538a2.306 2.306 0 0 0 2.306 2.306zm13.068-.768a.77.77 0 0 1-.769.768v1.538a2.306 2.306 0 0 0 2.306-2.306zm-.769-17.68a.77.77 0 0 1 .769.768h1.537a2.306 2.306 0 0 0-2.306-2.306zM20.924 9.537a2.306 2.306 0 0 0-2.306 2.306h1.538a.77.77 0 0 1 .768-.768zm1.538 6.15h3.074V14.15h-3.074zm0 5.38h9.224V19.53h-9.224zm0 3.075h9.224v-1.537h-9.224zm0 3.075h3.074V25.68h-3.074z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#312F2A",
      stroke: "#312F2A",
      "stroke-width": ".5",
      d: "M31.686 15.303a.384.384 0 1 0 0-.77.384.384 0 0 0 0 .77Z"
    }, null, -1)
  ]))]))
}
export default { render: render }